// Trims, drops blank/non-string entries, and de-duplicates a tag list so blank or
// duplicate chips are never hydrated, persisted, or rendered.
const normalizeTags = (values) => [
  ...new Set(
    (values || [])
      .filter((tag) => typeof tag === 'string')
      .map((tag) => tag.trim())
      .filter(Boolean),
  ),
];

export default normalizeTags;
